var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass:
        "price-category-nav bg-gray-0 rounded-20 px-4 py-6 align-self-start",
      class: { "price-category-nav--v5": _setup.ff_lpu_branding_page_v5 },
      attrs: { "data-qa": "lpu_page_price_categories" },
    },
    [
      _c("div", { staticClass: "text-subtitle-2 text-info--text pl-4 pb-3" }, [
        _vm._v("\n    " + _vm._s(_setup.tStatic("Категория")) + "\n  "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.items, function (item) {
        return _c(
          "button",
          {
            key: item.name,
            staticClass:
              "price-category-nav__item d-flex align-center text-left w-100 pa-4",
            class: {
              "price-category-nav__item--active rounded-10":
                item.name === _vm.activeName,
            },
            attrs: {
              type: "button",
              "data-qa": "lpu_page_price_category_item",
            },
            on: {
              click: function ($event) {
                return _setup.onSelect(item.name)
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "price-category-nav__name text-body-1 min-w-0" },
              [_vm._v(_vm._s(item.name))]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }